import PropTypes from 'prop-types';
import React from 'react';
import './styles.css';

const ImageBanner = ({ childTitle, childContent }) => {
  let heroBanner = '';
  if (childTitle === 'Identify') {
    heroBanner =
      'Hero Banner - Graphic of classroom of students with teacher standing at front';
  } else if (childTitle === 'Assist') {
    heroBanner =
      'Hero Banner - Teacher assisting student in a classroom setting';
  } else if (childTitle === 'Refer') {
    heroBanner = 'Hero Banner - Teacher directing student towards a door';
  }
  return (
    <div aria-label={heroBanner} className="image-hero">
      <div className="container">
        <div className="text-container">
          <h1>{childTitle}</h1>
        </div>
      </div>
    </div>
  );
};

ImageBanner.propTypes = {
  childTitle: PropTypes.node,
  childContent: PropTypes.node
};

ImageBanner.defaultProps = {
  childTitle: 'Title',
  childContent: null
};

const ImageHero = ImageBanner;

export default ImageHero;



// WEBPACK FOOTER //
// ./src/components/ImageBanner/index.jsx